import _ from 'lodash';
import ah from '../utils/ajax-helper'; // get user list

export var getUserList = function getUserList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'username';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword
    };
    ah.get("".concat(contextRoot, "/user/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get single user info

export var getUserInfo = function getUserInfo(contextRoot, noProgress, userId) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/user/").concat(userId), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create user

export var createUserAPI = function createUserAPI(contextRoot, noProgress, userData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/user/create"), JSON.stringify(userData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit user

export var editUserAPI = function editUserAPI(contextRoot, noProgress, userData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/user/edit"), JSON.stringify(userData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // forgot password

export var forgotPasswordAPI = function forgotPasswordAPI(contextRoot, noProgress, email, userName) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/user/forgot"), JSON.stringify({
      email: email,
      userName: userName
    }), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete user

export var deleteUserAPI = function deleteUserAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/user/delete"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete multiple user

export var deleteMultipleUserAPI = function deleteMultipleUserAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/user/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get authorizations

export var getAuthorizations = function getAuthorizations(contextRoot, noProgress) {
  return new Promise(function (resolve, reject) {
    ah.get("".concat(contextRoot, "/authorizations/list/all"), null, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // get role right list

export var getRoleRightList = function getRoleRightList(contextRoot, noProgress) {
  var keyword = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var sort = arguments.length > 3 ? arguments[3] : undefined;
  var offset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var limit = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'name';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'asc';
    var requestParameters = {
      offset: offset,
      limit: limit,
      sort: sortField + ':' + sortOrder,
      keyword: keyword
    };
    ah.get("".concat(contextRoot, "/group/list"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // create role right

export var createRoleRightAPI = function createRoleRightAPI(contextRoot, noProgress, groupData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/group/create"), JSON.stringify(groupData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // edit role right

export var editRoleRightAPI = function editRoleRightAPI(contextRoot, noProgress, groupData) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/group/edit"), JSON.stringify(groupData), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete role right

export var deleteRoleRightAPI = function deleteRoleRightAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/group/delete"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
}; // delete multiple role right

export var deleteMultipleRoleRightAPI = function deleteMultipleRoleRightAPI(contextRoot, noProgress, deleteItems) {
  return new Promise(function (resolve, reject) {
    ah.post("".concat(contextRoot, "/group/delete/all"), JSON.stringify(deleteItems), null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve();
    }).catch(function (error) {
      reject(error);
    });
  });
};